'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import useRudderStackAnalytics from './useRudderAnalytics';
const RudderAnalyticsProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const analytics = useRudderStackAnalytics();
  let t1;
  let t2;
  if ($[0] !== analytics) {
    t1 = () => {
      if (analytics) {
        analytics.page("Auto track");
      }
    };
    t2 = [analytics];
    $[0] = analytics;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <>{children}</>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default RudderAnalyticsProvider;